<template>
  <div class="section">
    <div class="product-detail">
      <div class="left">
        <div class="big_img">
          <img v-if="currentImage" :src="currentImage" @error="replaceWithDefaultImg" />
        </div>
        <ul class="small_img">
          <li v-for="(image, index) in data.products?.main_image_url" :key="index">
            <img
              class="img_b1"
              :src="image"
              :alt="'상세페이지_이미지' + (index + 1)"
              @click="currentImage = image"
              @error="replaceWithDefaultImg"
            />
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="product-title">
          [{{ data.products.brand }}]
          {{ data.products.product_name }}
        </div>

        <div class="product-info">
          <div class="info-row">
            <div class="info-label">정가</div>
            <div class="info-value">
              <span :class="productStatus.status == 'ing' && 'font-strike'">
                {{ _formatAmount(data.products.cost_price) }}원</span
              >
              <span v-show="productStatus.status == 'ing'" class="font-red"
                >{{ _getDiscountPercent(data.products.cost_price, data.products.selling_price) }}%
                할인</span
              >
            </div>
          </div>

          <!-- <div class="info-row">
            <div class="info-label">판매가</div>
            <div class="info-value">
              <span v-if="productStatus.status != 'before'"
                >{{ _formatAmount(data.products.retail_price) }}원</span
              ><span v-else> 오픈 예정 </span>
            </div>
          </div> -->

          <div class="info-row">
            <div class="info-label">공구가</div>
            <div class="info-value font-blue">
              <span v-if="productStatus.status == 'ing'">
                {{ _formatAmount(data.products.selling_price) }}원
              </span>
              <p v-else class="font-red">공구 진행중인 상품이 아닙니다</p>
            </div>
          </div>

          <!-- <div class="info-row">
            <div class="info-label">1인 최대 구매수량</div>
            <div class="info-value font-blue">{{ data.products.purchase_limit }}개</div>
          </div> -->

          <div class="info-row">
            <div class="info-label">배송비</div>
            <div class="info-value" v-if="data.deliveryInfo.shipping_free_tble > 0">
              <span> {{ _formatAmount(data.deliveryInfo.shipping) }}원 </span>
              <span class="font-sm" v-if="data.deliveryInfo.shipping_free_tble !== '999999'"
                >({{ _formatAmount(data.deliveryInfo.shipping_free_tble) }}원 이상 구매 시
                무료배송)</span
              >
            </div>
            <div class="info-value" v-else>
              <span>무료배송</span>
              </div>
          </div>

          <div class="info-row">
            <div class="info-label">판매기간</div>
            <div class="info-value">
              {{ data.products.var2 }} ~
              {{ data.products.var3 }}
              <div v-show="data.products.time_deal == 'Y'" class="time">
                <img src="../assets/images/clock.svg" />
                <div v-if="productStatus.status == 'before'">오픈까지</div>
                <div v-else>판매 종료까지</div>
                남은 시간
                <span class="font-red">{{ remaining.daysText }}</span>
                {{ remaining.hmsText }}
              </div>
            </div>
          </div>

          <div class="info-row">
            <div class="info-label">옵션</div>
            <div class="info-value">{{ option.option1.map(item => item.label).join('/ ') }}</div>
          </div>
        </div>

        <!-- [PC 전용] 옵션 선택 및 구매 영역 -->
        <!-- isMobile이 false일 때만 표시 -->
        <div v-if="!isMobile" class="pc-option-area">
          <div class="option-wrap">
            <div v-if="option.option1.length != 1" class="select-wrap">
              <select
                v-model="option.optionValue1"
                :disabled="
                  ['before', 'passed'].includes(productStatus.status) ||
                  data.products.is_soldOut == 'Y'
                "
                class="input-form"
                required
                @change="handleChange"
              >
                <option value="" disabled selected>옵션1</option>
                <option v-for="(item, index) in option.option1" :key="index" :value="item.value" :disabled="item.disabled">
                  {{ item.label }}
                </option>
              </select>
            </div>

            <div v-if="data.products?.options_2?.length > 0" class="select-wrap">
              <select
                v-model="option.optionValue2"
                :disabled="
                  ['before', 'passed'].includes(productStatus.status) ||
                  data.products.is_soldOut == 'Y'
                "
                class="input-form"
                required
                @change="handleChange2"
              >
                <option value="" disabled selected>
                  {{ option.option1.length == 1 ? '옵션' : '옵션2' }}
                </option>
                <option v-for="(item, index) in option.option2" :key="index" :value="item.value" :disabled="item.disabled">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>

          <div v-for="(item, index) in option.selectedOption" :key="index" class="option-select">
            <div class="row">
              <span class="name">
                {{ item.label1 }}<template v-if="item.label2"> [ {{ item.label2 }}]</template>
              </span>
              <button
                class="btn btn-qty"
                @click="decreaseCnt(item)"
              >
                -
              </button>
              <input
                v-model.number="item.cnt"
                type="number"
                class="input-form"
                min="1"
                max="5"
                @input="handleQuantityInput(item)"
                @blur="handleQuantityBlur(item)"
              />
              <button
                class="btn btn-qty"
                @click="increaseCnt(item)"
              >
                +
              </button>
              <button
                class="btn delete"
                @click="
                  () => {
                    option.optionValue1 = '';
                    option.optionValue2 = '';

                    option.selectedOption.splice(index, 1);
                    if (option.option1.length == 1) {
                      autoSelectOptionIfSingle();
                    }
                  }
                "
              ></button>
            </div>
            <div class="row bottom">
              {{ _formatAmount((data.price + item.addAmount) * item.cnt) }}원<span
                >({{ item.cnt }}개)</span
              >
            </div>
          </div>

          <div class="btn-wrap">
            <button
              v-if="productStatus.status == 'passed' || isTimeOver"
              class="btn btn-md btn-primary"
              disabled
            >
              판매종료된 상품입니다
            </button>
            <button
              v-else-if="data.products.is_soldOut == 'Y'"
              class="btn btn-md btn-primary"
              disabled
            >
              품절된 상품입니다
            </button>
            <button
              v-else-if="productStatus.status == 'before'"
              class="btn btn-md btn-primary"
              disabled
            >
              오픈 예정인 상품입니다.
            </button>
            <button v-else class="btn btn-md btn-blue" @click="handleBuyClick">
              <span style="margin-right: 4px">{{ _formatAmount(totalPrice) }}원</span> 바로 구매
            </button>
            <div
              v-if="userInfo.isSeller == 1 && ['before', 'ing'].includes(productStatus.status)"
              class="popover-wrap"
            >
              <button ref="btnRef" class="btn btn-md btn-line" @click="open = !open">
                공유하기
              </button>
              <div v-if="open" ref="popoverRef" class="popover">
                <div v-if="data.products.var4 != ''" class="text">
                  <span v-html="data.products.var4"></span>
                </div>
                <div class="share-wrap">
                  <input type="text" class="input-form" :value="COPY_TEXT" readonly />
                  <button class="btn btn-copy" @click="copyText"></button>
                  <button
                    id="kakaotalk-sharing-btn"
                    class="btn btn-kakao"
                    @click="shareKakao"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- // [PC 전용] 끝 -->

        <!-- <div class="product-detail--bottom">
          상품 발송 :
          <span class="font-orange">
            {{ isGuestProduct ? '14시 이전 주문 당일 출고' : '공구 종료 후 익일 발송' }}
          </span>
        </div> -->
      </div>
    </div>
    <ul class="sub_form tabs">
      <li class="tab-link" :class="{ current: activeTab === 'tab-1' }" @click="changeTab('tab-1')">
        상품상세
      </li>
      <li class="tab-link" :class="{ current: activeTab === 'tab-2' }" @click="changeTab('tab-2')">
        배송/교환환불 안내
      </li>
      <li class="tab-link" :class="{ current: activeTab === 'tab-3' }" @click="changeTab('tab-3')">
        판매자 정보
      </li>
    </ul>
    <div v-if="activeTab === 'tab-1'">
      <div class="product-detail--con" v-html="data.products.sub_image_url1"></div>
    </div>
    <div v-else-if="activeTab === 'tab-2'">
      <iframe
        :src="`https://api.3alliance.co.kr/randBox/term/deliveryTble.php?lang=ko&p=${productId}`"
        width="100%"
        height="1000"
        frameborder="0"
      ></iframe>
    </div>
    <div v-else-if="activeTab === 'tab-3'">
      <iframe
        :src="`https://api.3alliance.co.kr/randBox/term/seller_info.php?lang=ko&p=${productId}`"
        width="100%"
        height="1000"
        frameborder="0"
      ></iframe>
    </div>
  </div>

  <!-- [모바일 전용] 하단 고정 구매하기 버튼 -->
  <div v-if="isMobile && productStatus.status != 'before'" class="mobile-fix-btn">
    <button class="btn btn-lg btn-blue full-width" @click="openModal">구매하기</button>
  </div>
  <div   v-if="isMobile &&  productStatus.status == 'before'" class="mobile-fix-btn">
  <button

    class="btn btn-lg btn-primary full-width"
    disabled
  >
    오픈 예정인 상품입니다.
  </button>
</div>

  <!-- [모바일 전용] 구매 옵션 모달 -->
  <Transition name="fade">
    <div v-if="isModalOpen" class="modal-overlay" @click.self="closeModal">
      <Transition name="slide-up">
        <div v-if="isModalOpen" class="modal-content">
          <button class="btn-close" @click="closeModal">&times;</button>
          <h3 class="modal-title">옵션 선택</h3>

          <div class="option-form">
            <!-- 옵션 1 -->
            <div v-if="option.option1.length != 1" class="select-group">
              <label>옵션1 선택</label>
              <select
                v-model="option.optionValue1"
                :disabled="['before', 'passed'].includes(productStatus.status)"
                @change="handleChange"
              >
                <option value="" disabled selected>선택해주세요</option>
                <option v-for="(item, index) in option.option1" :key="index" :value="item.value" :disabled="item.disabled">
                  {{ item.label }}
                </option>
              </select>
            </div>

            <!-- 옵션 2 (데이터 있을 때만) -->
            <div v-if="data.products?.options_2?.length > 0" class="select-group">
              <label v-if="data.products?.options_1.length == 1">옵션 선택</label>
              <label v-else>옵션2 선택</label>
              <select
                v-model="option.optionValue2"
                :disabled="['before', 'passed'].includes(productStatus.status)"
                @change="handleChange2"
              >
                <option value="" disabled selected>선택해주세요</option>
                <option v-for="(item, index) in option.option2" :key="index" :value="item.value" :disabled="item.disabled">
                  {{ item.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- 선택된 옵션 리스트 (모바일 모달 내부 - 수량조절 포함) -->
          <div
            v-for="(item, index) in option.selectedOption"
            :key="`m-${index}`"
            class="option-select-modal"
          >
            <!-- 옵션명 + 삭제버튼 -->
            <div class="row">
              <span>{{ item.label1 }} {{ item.label2 }}</span>
              <button class="del-btn" @click="removeOption(index)">x</button>
            </div>

            <!-- 가격 + 수량조절 -->
            <div class="row bottom-row">
              <div class="qty-box">
                <button class="btn-qty" @click="decreaseCnt(item)">
                  -
                </button>
                <input
                  v-model.number="item.cnt"
                  type="number"
                  class="qty-input"
                  min="1"
                  max="5"
                  @input="handleQuantityInput(item)"
                  @blur="handleQuantityBlur(item)"
                />
                <button class="btn-qty" @click="increaseCnt(item)">+</button>
              </div>
              <span class="price-text">
                {{ _formatAmount((data.price + item.addAmount) * item.cnt) }}원
              </span>
            </div>
          </div>

          <!-- 최종 구매 버튼 -->
          <button class="btn btn-action primary" @click="handleBuyClick">
            <span v-if="totalPrice > 0" style="margin-right: 5px">
              {{ _formatAmount(totalPrice) }}원
            </span>
            구매하기
          </button>
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script setup>
import { useRoute } from 'vue-router';
import {
  ref,
  onMounted,
  reactive,
  computed,
  nextTick,
  watch,
  onUnmounted,
  onBeforeUnmount,
} from 'vue';
import { useRouter } from 'vue-router';
import { onClickOutside } from '@vueuse/core';
import axios from 'axios';
import Footer from '@/components/Footer.vue';
import img from '@/assets/images/Img.svg';

import {
  _formatAmount,
  _getStorageWithExpiry,
  _setStorageWithExpiry,
  _getIsGonggu,
  _getPeriodStatus,
  _safeAtob,
} from '../utils/common.js';
import Cookies from 'js-cookie';
import api from '@/utils/api.js';
import { trackViewItemList, getUserContext, gaSetUserProperties, gaEvent } from '@/utils/ga.js';
import Header from '@/components/Header.vue';
import { _getDiscountPercent } from '../utils/common.js';
import { _getRemainingTime } from '@/utils/common.js';

/* --- 모바일 감지 로직 --- */
const isMobile = ref(false);

const checkMobile = () => {
  const userAgent = navigator.userAgent;
  const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent,
  );
  const isSmallScreen = window.innerWidth <= 768; // 기준 폭 설정
  isMobile.value = isMobileAgent || isSmallScreen;
};

const isTimeOver = ref(false);
/* --- 모달 제어 상태 --- */
const isModalOpen = ref(false);

const openModal = () => {
  if (['before', 'passed'].includes(productStatus.status)) return;
  isModalOpen.value = true;
  // document.body.style.overflow = 'hidden';
};

const closeModal = () => {
  isModalOpen.value = false;
  // document.body.style.overflow = '';
};

/* --- 기존 로직 유지 --- */
function replaceWithDefaultImg(e) {
  e.target.onerror = null;
  e.target.src = img;
}

const currentImage = ref('');

let productStatus = reactive({
  status: '',
  daysLeft: 0,
});
const data = reactive({
  price: 0,
  products: {
    main_image_url: [],
    sub_image_url1: '',
    brand: '',
    product_name: '',
    cost_price: 0,
    retail_price: 0,
    selling_price: 0,
    var2: '',
    var3: '',
    var9: '',
    options_1: [],
    options_2: [],
    option_inven: [],
  },
  deliveryInfo: {},
});

const option = reactive({
  option1: [],
  option2: [],
  optionValue1: '',
  optionValue2: '',
  selectedOption: [],
});

let COPY_TEXT = ref('');
const open = ref(false);
const popoverRef = ref(null);
const router = useRouter();
const route = useRoute();
const code = route.params.code;
const activeTab = ref('tab-1');

const endAt = ref(null);
const remaining = ref({ daysText: '0일', hmsText: '00:00:00' });

let timerId = null;

const productId = computed(() => route.params?.code);

const userInfo = reactive({
  idntCode: _safeAtob(_getStorageWithExpiry('id')),
  isSeller: _safeAtob(_getStorageWithExpiry('sy')),
  sId: _getStorageWithExpiry('sId'),
  isGonggu: _getIsGonggu(),
  bId: '',
});

onMounted(() => {
  const queryId = route.query?.id;
  const idStr = Array.isArray(queryId) ? queryId[0] : queryId;

  if (idStr) {
    _setStorageWithExpiry('sId', String(idStr));
    userInfo.sId = idStr;
  }

  checkMobile();
  window.addEventListener('resize', checkMobile);

  postData();
  getDeliveryFee();

  const ctx = getUserContext();
  gaSetUserProperties(ctx);

  gaEvent('view_item', {
    page_name: 'product_detail',
    product_id: productId.value,
    product_seller_id: userInfo.sId,
    product_name: data.products.product_name,
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
  if (timerId) clearInterval(timerId);
});

onClickOutside(popoverRef, () => {
  open.value = false;
});

const totalPrice = computed(() => {
  return option.selectedOption.reduce((acc, item) => {
    return acc + (data.price * item.cnt + (item.addAmount || 0) * item.cnt);
  }, 0);
});

async function postData() {
  try {
    const response = await api.post('/goods.php', {
      mode: 'marketDetail',
      goods_code: code,
      type: 'G',
      idnt_code: userInfo.idntCode,
    });
    if (response.data) {
      data.products = response.data.data;
      // data.products.var2 = '2026-01-01'
      productStatus = _getPeriodStatus(data.products);
      // productStatus.status = 'before';
      // productStatus.daysLeft = 0;
      data.price = Number(
        userInfo.isGonggu && productStatus.status == 'ing'
          ? data.products.selling_price
          : data.products.retail_price,
      );

      currentImage.value = data.products?.main_image_url[0] || '';
      // COPY_TEXT.value = `https://tble.kr/mall?id=${_safeAtob(_getStorageWithExpiry('id'))}&prod=${
      //   data.products.goods_code
      // }`;

      COPY_TEXT.value = `${process.env.VUE_APP_DEFAULT_URL}productDetail/${
        data.products.goods_code
      }?id=${_safeAtob(_getStorageWithExpiry('id'))}`;

      changeOption1();

      setEndAtFromVar3(
        productStatus.status == 'before'
          ? `${data.products.var2} ${data.products.open_time}:00:00`
          : `${data.products.var3} 23:59:59`,
      );

      startTimer();
    } else {
      console.error('API 응답에 결과가 없습니다.');
    }
  } catch (error) {
    console.error('에러 발생:', error);
  }
}

function getOption2ListByOption1(option1Idx) {
  return data.products.options_2.filter(item => item.parent_idx === option1Idx);
}

function getInventoryByOptions(option1Idx, option2Idx) {
  // option2가 없는 경우
  if (!option2Idx) {
    return data.products.option_inven.find(inv => inv.parent_idx === option1Idx && !inv.child_idx);
  }

  // option2가 있는 경우
  return data.products.option_inven.find(
    inv => inv.parent_idx === option1Idx && inv.child_idx === option2Idx,
  );
}

function changeOption1() {
  const optionData = data.products.options_1.map(item => {
    const obj = getInventoryByOptions(item.idx, null);
    const amount =
      userInfo.isGonggu && productStatus.status == 'ing'
        ? obj?.option_add_price
        : obj?.option_add_cost;

    const amountStr = amount > 0 ? `(+${_formatAmount(amount)})` : '';
    const isSoldOut = obj && Number(obj.option_inven) <= 0;

    return {
      value: item.idx,
      label: `${item.option_title} ${amountStr}${isSoldOut ? ' [품절]' : ''}`,
      amount: amount,
      addAmount: item?.option_add_cost || 0,
      disabled: isSoldOut,
    };
  });
  if (code === 'ef04lA5') {
    optionData.splice(0, 1);
  }
  option.option1 = optionData;

  // 옵션1이 1개면 자동 선택
  if (optionData.length === 1) {
    autoSelectOptionIfSingle();
  }
}

function autoSelectOptionIfSingle() {
  const only = option.option1[0];
  if (only.disabled) return;
  option.optionValue1 = only.value;

  if ((data.products?.options_2 || []).length > 0) {
    changeOption2();
    return;
  }

  const obj = getInventoryByOptions(only.value, null);

  option.selectedOption.push({
    label1: only.label,
    value1: only.value,
    addAmount: Number(only.amount || 0),
    label2: '',
    value2: '',
    invenIdx: obj?.idx || '',
    cnt: 1,
  });

  option.optionValue1 = '';
  option.optionValue2 = '';
}

function changeOption2() {
  option.option2 = getOption2ListByOption1(option.optionValue1).map(item => {
    const obj = getInventoryByOptions(option.optionValue1, item.idx);
    const amount =
      userInfo.isGonggu && productStatus.status == 'ing'
        ? obj?.option_add_price
        : obj?.option_add_cost;
    const amountStr = amount > 0 ? `(+${_formatAmount(amount)})` : '';
    const isSoldOut = obj && Number(obj.option_inven) <= 0;

    return {
      value: item.idx,
      label: `${item.option_title} ${amountStr}${isSoldOut ? ' [품절]' : ''}`,
      amount: amount,
      disabled: isSoldOut,
      labelStyle: isSoldOut ? { color: '#9E9E9E' } : null,
    };
  });
}
function handleChange(event) {
  option.optionValue1 = event.target.value;

  if (data.products?.options_2?.length > 0) {
    changeOption2();
  } else {
    const data1 = option.option1.find(item => item.value === option.optionValue1);
    const obj = getInventoryByOptions(data1.value, null);

    if (option.selectedOption.find(item => item.value1 === data1.value)) {
      option.optionValue1 = '';
      option.optionValue2 = '';

      return;
    }

    option.selectedOption.push({
      label1: data1.label,
      value1: data1.value,
      addAmount: Number(data1.amount || 0),
      label2: '',
      value2: '',
      invenIdx: obj.idx || '',
      cnt: 1,
    });
    option.optionValue1 = '';
    option.optionValue2 = '';
  }
  requestAnimationFrame(() => event.target.blur());
}

function handleChange2(event) {
  const idx = event.target.value;
  const data1 = option.option1.find(item => item.value === option.optionValue1);
  const data2 = option.option2.find(item => item.value === idx);
  const obj = getInventoryByOptions(data1.value, data2.value);
  if (
    option.selectedOption.find(item => item.value1 === data1.value && item.value2 === data2.value)
  ) {
    alert('이미 선택된 옵션입니다.');

    option.optionValue1 = '';
    option.optionValue2 = '';
    if (option.option1.length == 1) {
      autoSelectOptionIfSingle();
    }
    return;
  }

  option.selectedOption.push({
    label1: data1.label,
    value1: data1.value,
    label2: data2.label,
    value2: data2.value,
    invenIdx: obj.idx || '',
    addAmount: Number(data2.amount || 0),
    cnt: 1,
  });

  option.optionValue1 = '';
  option.optionValue2 = '';
  option.option2 = [];

  if (option.option1.length == 1) {
    autoSelectOptionIfSingle();
  }
  requestAnimationFrame(() => event.target.blur());
}

function removeOption(index) {
  option.selectedOption.splice(index, 1);
}

const MAX_QTY = 5;
const QTY_LIMITED_CODES = ['ef04lA5'];
const isQtyLimited = QTY_LIMITED_CODES.includes(code);

function increaseCnt(item) {
  if (isQtyLimited && item.cnt >= MAX_QTY) {
    alert(`옵션별 최대 ${MAX_QTY}개까지 구매할 수 있습니다.`);
    return;
  }
  item.cnt += 1;
}

function decreaseCnt(item) {
  item.cnt = item.cnt <= 1 ? 1 : item.cnt - 1;
}

function handleQuantityInput(item) {
  if (!isQtyLimited) return;
  const val = Number(item.cnt);
  if (isNaN(val) || item.cnt === '' || item.cnt === null) return;
  if (val > MAX_QTY) {
    item.cnt = MAX_QTY;
    alert(`옵션별 최대 ${MAX_QTY}개까지 구매할 수 있습니다.`);
  } else if (val < 1) {
    item.cnt = 1;
  }
}

function handleQuantityBlur(item) {
  const val = Number(item.cnt);
  if (!item.cnt || isNaN(val) || val < 1) {
    item.cnt = 1;
  } else if (isQtyLimited && val > MAX_QTY) {
    item.cnt = MAX_QTY;
  }
}

function changeTab(tab) {
  activeTab.value = tab;
}

function handleBuyClick() {
  if (option.selectedOption.length <= 0) {
    alert('옵션을 선택해주세요.');
    return;
  }

  // 수량 안전 검증 (ef04lA5 상품만 1 ~ 5 범위 강제)
  if (isQtyLimited) {
    option.selectedOption.forEach(item => {
      const val = Number(item.cnt);
      if (isNaN(val) || val < 1) item.cnt = 1;
      else if (val > MAX_QTY) item.cnt = MAX_QTY;
    });
  }

  router.push({
    path: '/payment',
    state: {
      item: JSON.stringify(data.products),
      option: JSON.stringify(option.selectedOption),
    },
  });
}

function shareKakao() {
  if (!window.Kakao.isInitialized()) {
    window.Kakao.init('d87abca6f5c846e0ae5df9764f421025');
  }

  const id = _safeAtob(_getStorageWithExpiry('id'));

  gaEvent('share', {
    method: 'kakao',
    content_type: 'product',
    product_id: data.products.product_id,
    product_name: data.products.product_name,
    seller_id: id || '(none)',
    page_name: 'product_detail',
  });

  window.Kakao.Share.createDefaultButton({
    container: '#kakaotalk-sharing-btn',
    objectType: 'feed',
    content: {
      title: `[${data.products.brand}] ${data.products.product_name}`,
      description: `지금 티블에서만! [${data.products.brand}] ${data.products.product_name}, 공구가로 함께해요!`,
      imageUrl: data.products?.main_image_url[0],
      link: {
        mobileWebUrl: COPY_TEXT.value,
        webUrl: COPY_TEXT.value,
      },
    },
    buttons: [
      {
        title: '보기',
        link: {
          mobileWebUrl: COPY_TEXT.value,
          webUrl: COPY_TEXT.value,
        },
      },
    ],
  });
}

const copyText = async () => {
  const TEXT = `지금 티블에서만! [${data.products.brand}] ${data.products.product_name}, 공구가로 함께해요! ${COPY_TEXT.value}`;
  try {
    const perm = await navigator.permissions.query({ name: 'clipboard-write' });
    if (perm.state === 'denied') throw new Error('Permission denied');
    await navigator.clipboard.writeText(TEXT);
    alert('복사 되었습니다.');
  } catch (err) {
    const ta = document.createElement('textarea');
    ta.value = TEXT;
    ta.style.position = 'fixed'; // iOS 버그 방지
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    alert('복사 되었습니다.');
  }
};

const getDeliveryFee = async () => {
  const response = await api.post('/auth.php', {
    goods_code: code,
  });

  data.deliveryInfo = response.data.data;
};

function setEndAtFromVar3(var3) {
  const endStr = (var3 || '').toString().trim().replace(/[./]/g, '-');
  if (!endStr) {
    endAt.value = null;
    remaining.value = { daysText: '0일', hmsText: '00:00:00' };
    return;
  }

  endAt.value = new Date(endStr);
  remaining.value = _getRemainingTime(endAt.value);
}

function startTimer() {
  if (timerId) clearInterval(timerId);
  timerId = setInterval(() => {
    if (!endAt.value) return;

    remaining.value = _getRemainingTime(endAt.value);
    isTimeOver.value = endAt.value.getTime() <= Date.now();
  }, 1000);
}
</script>

<style scoped lang="scss"></style>
